// flow weak

/* eslint no-console:0 */
/* eslint consistent-return:0 */

/*
  imports
 */
import moment               from 'moment';
import { appConfig }        from '../../config';
import {
  getEarningGraphData
}                           from '../../services/API';
import {
  fetchMockEarningGraphData
}                           from '../../services/fetchMocks';
import * as ReduxTypes      from '../types';

/*
  constants
 */
const REQUEST_EARNING_GRAPH_DATA   = 'REQUEST_EARNING_GRAPH_DATA';
const RECEIVED_EARNING_GRAPH_DATA  = 'RECEIVED_EARNING_GRAPH_DATA';
const ERROR_EARNING_GRAPH_DATA     = 'ERROR_EARNING_GRAPH_DATA';

type EarningGraphDataset = {
  label: string,
  fillColor: string,
  strokeColor: string,
  pointColor: string,
  pointStrokeColor: string,
  pointHighlightFill: string,
  pointHighlightStroke: string,
  data: Array<number>
}


type EarningGraphState = {
  isFetching: boolean,
  labels:     Array<string>,
  datasets:   Array<EarningGraphDataset>,
  time:       string
};

/*
  reducer
 */
const initialState: EarningGraphState = {
  isFetching: false,
  labels:     [],
  datasets:   [],
  time:       null
};

export default function earningGraph(state = initialState, action) {
  switch (action.type) {
  case 'REQUEST_EARNING_GRAPH_DATA':
    return {
      ...state,
      isFetching: action.isFetching,
      time:       action.time
    };
  case 'RECEIVED_EARNING_GRAPH_DATA':
    return {
      ...state,
      isFetching: action.isFetching,
      labels:     action.labels,
      datasets:   action.datasets,
      time:       action.time
    };
  case 'ERROR_EARNING_GRAPH_DATA':
    return {
      ...state,
      isFetching: action.isFetching,
      time:       action.time
    };
  default:
    return state;
  }
}


/*
  action creators
 */
export function fetchEarningGraphDataIfNeeded(id) {
  return (
    dispatch, 
    getState
  ) => {
    if (shouldFetchEarningData(getState())) {
      return dispatch(fetchEarningGraphData(id));
    }
  };
}
function requestEarningGraphData(time = moment().format()) {
  return {
    type:       REQUEST_EARNING_GRAPH_DATA,
    isFetching: true,
    time
  };
}
function receivedEarningGraphData(data, time = moment().format()) {
  console.log('Nikhilesh - receivedEarningGraphData');
  console.log(...data);
  return {
    type:       RECEIVED_EARNING_GRAPH_DATA,
    isFetching: false,
    labels:     [...data.labels],
    datasets:   [...data.datasets],
    time
  };
}
function errorEarningGraphData(error, time = moment().format()) {
  return {
    type:       ERROR_EARNING_GRAPH_DATA,
    isFetching: false,
    error,
    time
  };
}
function fetchEarningGraphData(id=0) {
  return dispatch => {
    dispatch(requestEarningGraphData());
      getEarningGraphData(id)
        .then(
          data => dispatch(receivedEarningGraphData(data))
        )
        .catch(
          error => dispatch(errorEarningGraphData(error))
        );
  };
}
function shouldFetchEarningData(state) {
  const earningGraphStore = state.earningGraph;
  // just check wether fetching (assuming data could be refreshed and should not persist in store)
  if (earningGraphStore.isFetching) {
    return false;
  } else {
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/modules/earningGraph.js